import React from "react";
import {
  AnchorButton,
  Icon,
  Intent,
  ProgressBar,
  Collapse,
  Colors
} from "@blueprintjs/core";
import { compose, withState, withHandlers, branch } from "recompose";
import styled from "styled-components";
import { withLocationFeedback } from "./hocs";
import { FEEDBACK } from "./constants";
import ScoreBadge from "./ScoreBadge";
import { FormattedMessage } from "react-intl";

const enhance = compose(
  branch(props => !props.noFeedback, withLocationFeedback),
  withState("isOpen", "setIsOpen", props => props.isOpen || false),
  withHandlers({
    toggleOpen: props => () => {
      const { isOpen, setIsOpen } = props;
      setIsOpen(!isOpen);
    }
  })
);

const FeedbackErrorStyle = styled.div`
  font-size: 12px;
  color: ${Colors.GRAY4};
`;

const LocationFeedback = enhance(props => {
  const className = props.className;
  const feedback = props.locationFeedback;
  if (!feedback) return null;
  if (feedback[FEEDBACK.PENDING]) {
    return (
      <div className={className}>
        <ProgressBar />
      </div>
    );
  }
  if (feedback[FEEDBACK.ERROR]) {
    return (
      <div className={className}>
        <Icon iconName="warning-sign" intent={Intent.WARNING} /> Error loading
        feedback{" "}
        <AnchorButton
          className={"pt-minimal"}
          onClick={props.reloadFeedback}
          title="Retry"
          iconName="refresh"
        />
        {feedback.data && (
          <FeedbackErrorStyle>{feedback.data.message}</FeedbackErrorStyle>
        )}
      </div>
    );
  }
  const message = feedback.data.message;
  let reasons = feedback.data.items || [];
  if (feedback.data.score !== 0) {
    return (
      <div className={className}>
        <Icon iconName="small-tick" intent={Intent.SUCCESS} />{" "}
        <FormattedMessage
          id="feedback.label"
          defaultMessage="Location feedback"
        />
        {message && ` "${message}" `} -{" "}
        <FormattedMessage id="text.score" defaultMessage="Score" />
        {": "}
        <ScoreBadge score={feedback.data.score} />
        <br />
        {reasons.length > 0 && (
          <span>
            <a onClick={props.toggleOpen}>
              {props.isOpen ? (
                <span>
                  <Icon iconName="caret-down" />
                  <FormattedMessage
                    id="feedback.hidereasons"
                    defaultMessage="Hide reasons ({reasons})"
                    values={{ reasons: reasons.length }}
                  />
                </span>
              ) : (
                <span>
                  <Icon iconName="caret-right" />
                  <FormattedMessage
                    id="feedback.showreasons"
                    defaultMessage="Show reasons ({reasons})"
                    values={{ reasons: reasons.length }}
                  />
                </span>
              )}
            </a>
            <Collapse isOpen={props.isOpen}>
              <ol>
                {reasons.map((item, index) => (
                  <li key={index}>
                    {item.message && item.message}
                    {typeof item.score === "number" && (
                      <span>
                        , Score: <ScoreBadge score={item.score} />
                      </span>
                    )}
                    {item.origin && `, origin: ${item.origin}`}
                  </li>
                ))}
              </ol>
            </Collapse>
          </span>
        )}
      </div>
    );
  }
  return (
    <div className={className}>
      <Icon iconName="small-cross" intent={Intent.DANGER} />{" "}
      <FormattedMessage
        id="feedback.label"
        defaultMessage="Location feedback"
      />
      {message && ` "${message}" `} -{" "}
      <FormattedMessage id="text.score" defaultMessage="Score" />:{" "}
      <ScoreBadge score={feedback.data.score} />
      <br />
      {message && ` "${message}" `}
      {reasons.length > 0 && (
        <span>
          <a onClick={props.toggleOpen}>
            {props.isOpen ? (
              <span>
                <Icon iconName="caret-down" />
                <FormattedMessage
                  id={"feedback.hidereasons"}
                  defaultMessage={"Hide reasons ({reasons})"}
                  values={{ reasons: reasons.length }}
                />
              </span>
            ) : (
              <span>
                <Icon iconName="caret-right" />
                <FormattedMessage
                  id={"feedback.showreasons"}
                  defaultMessage={"Show reasons ({reasons})"}
                  values={{ reasons: reasons.length }}
                />
              </span>
            )}{" "}
          </a>
          <Collapse isOpen={props.isOpen}>
            <ol>
              {reasons.map((item, index) => (
                <li key={index}>
                  {item.message && item.message}
                  {typeof item.score === "number" && (
                    <span>
                      , Score: <ScoreBadge score={item.score} />
                    </span>
                  )}
                  {item.origin && `, origin: ${item.origin}`}
                </li>
              ))}
            </ol>
          </Collapse>
        </span>
      )}
    </div>
  );
});

export default LocationFeedback;



// WEBPACK FOOTER //
// ./src/app/feedback/LocationFeedback.js